import {useEffect, useState} from "react";
import store from "../../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../../actions/global-actions";
import SvgIcon from "../../../components/svg-icon";
import {useSelector} from "react-redux";
import Loading from "../../../components/loading";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";

const ChatRules = () => {

    const {activeLanguage} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    const [loading, setLoading] = useState(true)
    const [content, setContent] = useState('')

    useEffect(() => {
        if (activeLanguage?.key) {

            associateServices.getChatMessageRules({
                language: activeLanguage.key
            }).then(res => {
                setContent(res?.data || null)
                setLoading(false)
            })
        }
    }, [activeLanguage?.key])
    useEffect(() => {
        const bdy = document.body
        bdy?.classList?.add('modal-open')

        const mdl = document.getElementById('manual-modal')
        mdl?.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'
    }, [])

    const handleClose = () => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))


    return (
        <div
            className="modal fade"
            id="manual-modal"
            tabIndex={-1}
            aria-labelledby="manual-modal"
            aria-hidden="true"
            onClick={handleClose}

        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title"/>
                            <button
                                className="modal__close"
                                type="button"
                                aria-label="Close"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>

                        <div className="modal__scrollable">

                            {
                                loading ? <Loading/> :
                                    <div className="article">
                                        <div dangerouslySetInnerHTML={{__html: content?.content || ''}}/>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )


}

export default ChatRules
